import React from "react";
import "./Facilities.css";
import {
  FaSchool,
  FaSnowflake,
  FaLock,
  FaChalkboardTeacher,
  FaVideo,
  FaUserGraduate,
} from "react-icons/fa";

const icons = [
  <FaSchool />,
  <FaSnowflake />,
  <FaLock />,
  <FaChalkboardTeacher />,
  <FaVideo />,
  <FaUserGraduate />,
];

const Facilities = ({ data }) => {
  return (
    <section className="Founder">
      <div className="Founder-container landing-pages">
        <p className="founder-subtitle">{data?.facilitiesSubtitle}</p>

        <h2 className="founder-title">
          {data?.facilitiestitle?.split(" ").slice(0, -1).join(" ")}
              <span> {data?.facilitiestitle?.split(" ").slice(-1).join(" ")}</span>
        </h2>

        <div className="facilities-grid">
          {data?.facilitiesItems?.map((item, i) => (
            <div key={i} className="facility-card ageeligibility-card">
              <div className="facility-icon">{icons[i]}</div>
              <h4>{item.title}</h4>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Facilities;
